(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["av-footer-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-footer-links')) {
    customElements.define('av-footer-links', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(min-width: 990px)');
        this.syncBreakpoint = () => {
          const disclosure = this.querySelector('details');
          if (disclosure) disclosure.open = this.breakpoint.matches;
        };
        this.syncBreakpoint();
        this.breakpoint.addEventListener('change', this.syncBreakpoint);
      }
      disconnectedCallback() {
        this.breakpoint?.removeEventListener('change', this.syncBreakpoint);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
